/* eslint-disable no-console */
import { reactive, ref } from "vue";
import type { UserContext } from "../context";
// import type { UserPermissions } from "@/models";
import type { AxiosError } from "axios";
import { useAuthApi } from "@/core/composables/useAuthApi";
import { useUserProfileApi } from "@/core/composables/useUserProfileApi";
// import { RoleEnum } from "@/core/enum";
import { useAppContextStore } from "../AppContextStore";

export const data = ref(null);
export const authenticated = ref(false);

// Legacy mutable object (try to phase out)
// export const context: UserContext = {
//   id: "1",
//   email: "resumebuilder@platotech.com",
//   role: RoleEnum.ADMINISTRATOR,
//   resumeId: 1,
//   manager: {} as any,
//   managedEmployees: [],
//   permissions: { page: {} } as unknown as UserPermissions,
//   firstName: "",
//   lastName: "",
//   authenticated: false,
// };

function applyUserContext(ctx: UserContext) {
  (ctx.permissions as any) ??= {};
  (ctx.permissions as any).data ??= {};
  (ctx.permissions as any).page ??= {};

  ctx.authenticated = true;
  authenticated.value = true;
}

export async function load() {
  const { fetchToken } = useAuthApi();
  const { fetchUserProfile, userContext } = useUserProfileApi();
  const appContext = useAppContextStore();

  try {
    await fetchToken({ id: "1" });

    const ctx = await fetchUserProfile(); // use return value if available
    const resolved = ctx ?? userContext.value;

    applyUserContext(resolved);

    appContext.setUserContext(resolved);

    // Object.assign(context, resolved);
    // context.authenticated = true;
  } catch (error) {
    authenticated.value = false;
    // context.authenticated = false;
    appContext.resetAll();
    throw error as AxiosError;
  }
}

export const mockUser = reactive({
  data,
  authenticated,
  load,
});
